export default "__VITE_ASSET__D7Q8bckN__"